import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=4ffa7656&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ffa7656')) {
      api.createRecord('4ffa7656', component.options)
    } else {
      api.reload('4ffa7656', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=4ffa7656&", function () {
      api.rerender('4ffa7656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/dropdown/src/menu.vue"
export default component.exports